import HasRole from "modules/5_view_helpers/HasRole";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getDrawingOfficeNav = (project_id, drawing_office_custom_forms, drawing_office_menus) => {
  const SiteDocumentReleaseRoles = HasRole({
    resource_type: "Project::SiteDocumentRelease",
  });
  const ProjectDrawingRole = HasRole({
    resource_type: "Project::Drawing",
  });
  const DrawingTypesRoles = HasRole({
    resource_type: "DrawingOffice::DrawingType",
  });

  const CommunicationsStatusesRoles = HasRole({ resource_type: "Project::Communications::Status", name: ["read", "moderator"] });
  const CommunicationsOutgoingTypesRoles = HasRole({ resource_type: "Project::Communications::OutgoingType", name: ["read", "moderator"] });

  const DrawingOfficeRoles = SiteDocumentReleaseRoles || ProjectDrawingRole || DrawingTypesRoles;

  if (DrawingOfficeRoles || _.isNotEmpty(drawing_office_custom_forms) || _.isNotEmpty(drawing_office_menus)) {
    let drawingOfficeMenu = { icon: "fa fa-pencil", label: "Drawing Office", content: [] };

    if (SiteDocumentReleaseRoles) {
      drawingOfficeMenu?.content.push({
        label: "Site Document Releases",
        to: `/project/${project_id}/site_document_releases`,
      });
    }
    if (ProjectDrawingRole) {
      drawingOfficeMenu?.content.push({
        label: "Drawings",
        to: `/project/${project_id}/drawings`,
      });
    }

    const SettingsRoles = DrawingTypesRoles || CommunicationsStatusesRoles || CommunicationsOutgoingTypesRoles;

    if (SettingsRoles) {
      drawingOfficeMenu?.content.push({
        label: "Settings",
        to: `/drawing_office/settings`,
      });
    }

    drawingOfficeMenu.content = _.concat(
      drawingOfficeMenu?.content,
      createCustomFormLinks(drawing_office_custom_forms),
      createMenuItems(drawing_office_menus)
    );
    return drawingOfficeMenu;
  }
};

export default getDrawingOfficeNav;
